export const SET_BILLING_STORE = "SET_BILLING_STORE";
export const SET_BILLING_RESET = "SET_BILLING_RESET";

// Lấy thông tin Billing
export const FETCH_BILLING_INFO_REQUEST = "FETCH_BILLING_INFO_REQUEST";
export const FETCH_BILLING_INFO_SUCCESS = "FETCH_BILLING_INFO_SUCCESS";
export const FETCH_BILLING_INFO_FAILURE = "FETCH_BILLING_INFO_FAILURE";

// Lấy thông tin gói
export const FETCH_BILLING_PACKAGE_REQUEST = "FETCH_BILLING_PACKAGE_REQUEST";
export const FETCH_BILLING_PACKAGE_SUCCESS = "FETCH_BILLING_PACKAGE_SUCCESS";
export const FETCH_BILLING_PACKAGE_FAILURE = "FETCH_BILLING_PACKAGE_FAILURE";

// Lấy thông tin tài khoản
export const FETCH_BILLING_CUSTOMER_INFO_REQUEST = "FETCH_BILLING_CUSTOMER_INFO_REQUEST";
export const FETCH_BILLING_CUSTOMER_INFO_SUCCESS = "FETCH_BILLING_CUSTOMER_INFO_SUCCESS";
export const FETCH_BILLING_CUSTOMER_INFO_FAILURE = "FETCH_BILLING_CUSTOMER_INFO_FAILURE";

// Lấy thông tin chi tiết phí
export const FETCH_BILLING_MAKE_FEE_REQUEST = "FETCH_BILLING_MAKE_FEE_REQUEST";
export const FETCH_BILLING_MAKE_FEE_SUCCESS = "FETCH_BILLING_MAKE_FEE_SUCCESS";
export const FETCH_BILLING_MAKE_FEE_FAILURE = "FETCH_BILLING_MAKE_FEE_FAILURE";

// Nhập liệu
export const FETCH_BILLING_CREATE_REQUEST = "FETCH_BILLING_CREATE_REQUEST";
export const FETCH_BILLING_CREATE_SUCCESS = "FETCH_BILLING_CREATE_SUCCESS";
export const FETCH_BILLING_CREATE_FAILURE = "FETCH_BILLING_CREATE_FAILURE";

// Xác nhận
export const FETCH_BILLING_CONFIRM_REQUEST = "FETCH_BILLING_CONFIRM_REQUEST";
export const FETCH_BILLING_CONFIRM_SUCCESS = "FETCH_BILLING_CONFIRM_SUCCESS";
export const FETCH_BILLING_CONFIRM_FAILURE = "FETCH_BILLING_CONFIRM_FAILURE";

// Xác thực
export const FETCH_BILLING_AUTHORIZATION_KEY_REQUEST = "FETCH_BILLING_AUTHORIZATION_KEY_REQUEST";
export const FETCH_BILLING_AUTHORIZATION_KEY_SUCCESS = "FETCH_BILLING_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_BILLING_AUTHORIZATION_KEY_FAILURE = "FETCH_BILLING_AUTHORIZATION_KEY_FAILURE";
